import React, { useState, useEffect } from 'react';
import $ from 'jquery';
import QueryForm from './QueryForm';
import UpcomingList from './UpcomingList';
import ListPager from './ListPager';
import Loader from './Loader';
import { AJAX_URL } from '../../config/index.js';

export default function EventsList() {
  const [isLoading, setLoading] = useState(true);
  const [eventList, setEventList] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [featuredList, setFeaturedList] = useState([]);
  const [query, setQuery] = useState({});

  // Pagination State
  const [limit, setLimit] = useState(8);
  const [pagerIndex, setPagerIndex] = useState(0);
  const [paginatedEvents, setPaginatedEvents] = useState([]);
  const [paginatedFeatured, setPaginatedFeatured] = useState([]);
  const [totalPages, setTotalPages] = useState(1);

  const handlePagination = (list, currentIndex, featured = false) => {
    !featured ? setTotalPages(Math.ceil(list.length / limit)) : '';
    const lastPage = totalPages - 1;

    if (!featured) {
      if (currentIndex >= totalPages) {
        setPagerIndex(0);
        return;
      } else if (currentIndex < 0) {
        setPagerIndex(lastPage);
        return;
      }
    }

    const startIndex = limit * currentIndex;
    const endIndex = startIndex + limit;
    const selection = list.slice(startIndex, endIndex);
    !featured ? setPaginatedEvents(selection) : setPaginatedFeatured(selection);
  };

  const prevPage = () => {
    setPagerIndex(pagerIndex - 1);
  };

  const nextPage = () => {
    setPagerIndex(pagerIndex + 1);
  };

  useEffect(() => {
    setLoading(true);
    const fetchEvents = async (query) => {
      await $.ajax({
        type: 'POST',
        url: `${AJAX_URL}post_wlQueryProducts`,
        dataType: 'json',
        encode: true,
        data: query,
        contentType: 'application/x-www-form-urlencoded; charset=UTF-8'
      })
        .then((res) => {
          setEventList(res.data.slice(1)[0]);
          setCategoryList(res.data[0]);
        })
        .catch((err) => console.log(err.message));
    };

    fetchEvents(query);
    setPagerIndex(0);

  }, [query, limit]);

  useEffect(() => {
    eventList.length > 0 ? setTimeout(() => {setLoading(false);}, 500) : '';
    handlePagination(eventList, pagerIndex);
  }, [eventList]);

  useEffect(() => {
    handlePagination(eventList, pagerIndex);
  }, [pagerIndex, featuredList, limit]);

  return (
    <div>
      <QueryForm updateQuery={setQuery} terms={categoryList}/>
      {isLoading ? (
        <Loader />
      ) : (
        <div>
          <UpcomingList
            isLoading={isLoading}
            product={paginatedEvents}
          />
          <ListPager
            changeLimit={setLimit}
            limit={limit}
            setPagerIndex={setPagerIndex}
            nextPage={nextPage}
            prevPage={prevPage}
            pagerIndex={pagerIndex}
            totalEvents={eventList.length}
            totalPages={totalPages}
            paginatedItemCount={paginatedEvents.length}
          />
        </div>
      )}
    </div>
  );
}
